import React from 'react';
import PropTypes from 'prop-types';

const RowerCard = ({
  rower,
  isAssigned = false,
  onDragStart,
  onDragEnd,
  showStatus = false,
  isDragging = false,
}) => {
  const handleDragStart = (e) => {
    console.log('RowerCard: Drag start called for rower:', rower);
    if (onDragStart) {
      onDragStart(e, rower);
    } else {
      console.warn('RowerCard: No onDragStart handler provided');
    }
  };

  const handleDragEnd = (e) => {
    console.log('RowerCard: Drag end called for rower:', rower);
    if (onDragEnd) {
      onDragEnd(e);
    }
  };

  // Get side preference indicator
  const getSidePreferenceIndicator = () => {
    const sidePreference = rower.preferred_side;

    switch (sidePreference) {
      case 'port':
        return {
          text: 'Port',
          className: 'bg-red-100 text-red-800 px-2 py-0.5 rounded-full text-xs font-medium',
        };
      case 'starboard':
        return {
          text: 'Starboard',
          className: 'bg-green-100 text-green-800 px-2 py-0.5 rounded-full text-xs font-medium',
        };
      case 'both':
        return {
          text: 'Both',
          className: 'bg-blue-100 text-blue-800 px-2 py-0.5 rounded-full text-xs font-medium',
        };
      case 'none':
        return {
          text: 'No Preference',
          className: 'bg-gray-100 text-gray-800 px-2 py-0.5 rounded-full text-xs font-medium',
        };
      default:
        return {
          text: 'No Preference',
          className: 'bg-gray-100 text-gray-800 px-2 py-0.5 rounded-full text-xs font-medium',
        };
    }
  };

  const sideInfo = getSidePreferenceIndicator();

  return (
    <div
      draggable={!!onDragStart && !isAssigned}
      onDragStart={handleDragStart}
      onDragEnd={handleDragEnd}
      className={`
                cursor-pointer rounded-lg border p-3 transition-all duration-200
                ${isDragging ? 'scale-95 opacity-50' : ''}
                ${
                  isAssigned
                    ? 'cursor-default border-green-200 bg-green-50'
                    : 'border-gray-200 bg-white hover:border-blue-300 hover:shadow-md'
                }
                ${!!onDragStart && !isAssigned ? 'hover:cursor-grab active:cursor-grabbing' : ''}
            `}
    >
      <div className="flex items-center">
        <div className="mr-3 flex h-10 w-10 items-center justify-center rounded-full bg-blue-500 text-sm font-semibold text-white">
          {rower.first_name[0]}
          {rower.last_name[0]}
        </div>
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-2">
            <div className="truncate font-medium text-gray-900">
              {rower.first_name} {rower.last_name}
            </div>
            {/* Side preference indicator */}
            <span className={`${sideInfo.className}`} title={`Prefers ${sideInfo.text} side`}>
              {sideInfo.text}
            </span>
            {/* Note: Users don't have strict side preferences, only crews do */}
          </div>
          <div className="truncate text-sm text-gray-500">{rower.email}</div>
        </div>
        {isAssigned && (
          <div
            className="ml-2 flex h-6 w-6 items-center justify-center rounded-full bg-green-500 text-sm text-white"
            title="Already in this crew"
          >
            ✓
          </div>
        )}
      </div>
    </div>
  );
};

RowerCard.propTypes = {
  rower: PropTypes.object.isRequired,
  isAssigned: PropTypes.bool.isRequired,
  onDragStart: PropTypes.func.isRequired,
};

export default RowerCard;
